module.exports = __webpack_public_path__ + "static/img/bjyy.0496f6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjyy.png
// module id = d/w1
// module chunks = 0